import { render, staticRenderFns } from "./emptyActionParams.vue?vue&type=template&id=5bbe4781"
import script from "./emptyActionParams.vue?vue&type=script&lang=js"
export * from "./emptyActionParams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports